<template>
  <div class="divmain">
    <el-row>
      <el-col :span="24" class="divcontent">
        <h3>门店网点</h3>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <el-col :span="24" class="divcontent">
        <el-card class="box-card" style="float: none;margin:0 auto 20px auto">
          <div slot="header" class="clearfix">
            <span>总部门市</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="gotoMap(121.553139,29.872600,'宁波市海曙区开明街396号平安大厦12楼')">查看地图</el-button>
          </div>
          <div class="text_item">
            <i class="el-icon-mobile"></i> 0574-87978797
          </div>
          <div class="text_item">
            <i class="el-icon-location-outline"></i> 宁波市海曙区开明街396号平安大厦12楼
          </div>
        </el-card>
        <div style="text-align:center;margin-bottom:20px;">
          <el-button type="success" @click="showmdmap">查看所有分店地图分布</el-button>
        </div>
        <div class="clearfix"></div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="item.district_name" :name="'d_'+idx" v-for="(item,idx) in cc_group" :key="item.district_id">
            <div class="box-card_flex">
              <el-card class="box-card" v-for="cc in item.data" :key="cc.cits_company_id">
                <div slot="header" class="clearfix">
                  <span>{{cc.cits_company_title}}</span>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="gotoMap(cc.cits_company_longitude,cc.cits_company_latitude,cc.cits_company_add)">查看地图</el-button>
                </div>
                <div class="text_item">
                  <i class="el-icon-mobile"></i> {{cc.cits_company_tel}}
                </div>
                <div class="text_item">
                  <i class="el-icon-location-outline"></i> {{cc.cits_company_add}}
                </div>
              </el-card>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCitsCompany } from "@/api/ayv3/base";
export default {
  name: "contant",
  components: {

  },
  data() {
    return {
      loading: true,
      activeName: 'd_0',
      cc_group: []
    }
  },
  methods: {
    //取门店
    getCitsCompany() {
      var map = {};
      getCitsCompany({}).then(res => {
        if (res.data.code === 0) {
          for (var i = 0; i < res.data.data.length; i++) {
            var ai = res.data.data[i];
            if (!map[ai.district_id]) {
              this.cc_group.push({
                district_id: ai.district_id,
                district_name: ai.district_name,
                data: [ai]
              });
              map[ai.district_id] = ai;
            } else {
              for (var j = 0; j < this.cc_group.length; j++) {
                var dj = this.cc_group[j];
                if (dj.district_id == ai.district_id) {
                  dj.data.push(ai);
                  break;
                }
              }
            }
          }
          this.loading = false;
        } else {
          this.$alert(res.data.message, '提示');
        }
      })
    },
    handleClick(tab, event) {
    },
    gotoMap(lon, lat, name) {
      window.location.href = `https://uri.amap.com/marker?position=${lon},${lat}&name=${name}`;
    },
    showmdmap(){
      this.$router.push({ name: 'mdmap' });
    }
  },
  mounted() {
    this.getCitsCompany();
  }
};
</script>
<style lang="less">
.box-card {
  float: left;
  width: 100%;
  max-width: 250px;
  height: 200px;
  margin: 0 20px 20px 0;
  .text_item {
    i {
      font-size: 18px;
    }
  }
}
.box-card_flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-star;
  .text_item {
    i {
      font-size: 18px;
    }
  }
}
</style>

